<template>
  <Header/>

  <div class="w-content-standard mx-auto mb-8 pt-10">
    <FormKit id="login-form" type="form" @submit.prevent="submit" :actions="false">
      <!-- Display the error message if it exists -->
      <p v-if="error_message" class="error">{{ error_message }}</p>

      <div class="mb-4">
        <FormKit
            type="text"
            v-model="email"
            label="Email"
            validation="required"
            placeholder="Email"
        />
      </div>

      <div class="mb-8">
        <FormKit
            type="password"
            v-model="password"
            label="Password"
            validation="required"
            placeholder="Password"
        />
      </div>

      <ButtonComponent type="submit" class="form-link-button" @click.prevent="submit" :loading="is_loading">
        Login
      </ButtonComponent>
    </FormKit>
  </div>
</template>

<script>
import { ref } from 'vue';
import ButtonComponent from "../components/ButtonComponent.vue";
import Header from "./Header.vue";
import axios from 'axios';

export default {
  components: {ButtonComponent,Header},
  setup() {
    const email = ref();
    const password = ref();
    const error_message = ref(''); // Initialize the error_message ref
    const is_loading = ref(false)

    const submit = () => {
      console.log('starting submit')
      is_loading.value = true

      axios.post('/api/login', {
        email: email.value,
        password: password.value,
      })
      .then(response => {
        window.location.href = '/#/'; // Redirect on success to hash route
      })
      .catch(error => {
        // Check if error response exists and set the error_message ref
        if (error.response && error.response.data && error.response.data.message) {
          error_message.value = error.response.data.message;
        } else {
          error_message.value = 'An unexpected error occurred.';
        }
        console.error('Error logging in:', error);
      })
      .finally(() => {
        is_loading.value = false
      })
    };

    return {
      email,
      password,
      submit,
      error_message,
      is_loading
    };
  },
};
</script>

<style scoped>
.error {
  color: red;
}
</style>